/* tslint:disable */
//  This file was automatically generated and should not be edited.
export enum PostType {
  /**
   * Album
   */
  POST_ALBUM = "POST_ALBUM",
  /**
   * Článok
   */
  POST_ARTICLE = "POST_ARTICLE",
  /**
   * Krátka správa
   */
  POST_SHORT_MESSAGE = "POST_SHORT_MESSAGE",
}export enum PostCategory {
  /**
   * Album
   */
  REGULAR_ALBUM = "REGULAR_ALBUM",
  /**
   * Firemný album
   */
  VENDOR_ALBUM = "VENDOR_ALBUM",
  /**
   * Svadobný album
   */
  WEDDING_ALBUM = "WEDDING_ALBUM",
}export enum PostVisibility {
  /**
   * Len pre registrovaných
   */
  POST_VISIBILITY_AUTHENTICATED = "POST_VISIBILITY_AUTHENTICATED",
  /**
   * Len pre priateľov
   */
  POST_VISIBILITY_FRIENDS = "POST_VISIBILITY_FRIENDS",
  /**
   * Pre všetkých
   */
  POST_VISIBILITY_PUBLIC = "POST_VISIBILITY_PUBLIC",
}